import { lazyLoad } from 'utils/loadable';

export const UserFormPage = lazyLoad(
  () => import('./index'),
  module => module.UserFormPage,
);
